<template>
  <tx-msg-box ref="basketQueListMsg" class="comp-basket-question-list-pop" @close="close" :options="{ type: 'custom', title: '试题篮试题列表', width: '1000px', showClose: true,showConfirmButton: true, confirmButtonText: '生成试卷', confirmButtonClass: 'btn-primary', callback: bindCreatePaper, callbackClose: true}">
    <div v-for="(listItem, key) in list" :key="key" :title="key">
      <div class="tc" style="font-size:28px; padding:20px 0;"><strong>{{listItem[0].typesName}}</strong><span class="f14"> (共<span class="text-orange">{{listItem | typeQuesNum}}</span>题)</span></div>
      <tx-question-item
        ref="QuestionItem"
        :item="testList[item.testID]" v-for="item in listItem"
        :key="item.testID"
        page="paperDetail"
        :show-collect="false"
        :show-btns="false"
        show-del
      ></tx-question-item>
    </div>
  </tx-msg-box>
</template>

<script>
  /*!*
   * @author yueheqin
   * @date 2019/10/17
   * @project zujuanzaixian
   * @desc
   */
  import {mapMutations, mapGetters, mapState} from 'vuex'
  import {basketCreatePaperMixin} from '../../mixins/create-paper'

  export default {
    name: 'comp-basket-question-list-pop',
    mixins: [basketCreatePaperMixin],
    props: {
    },
    data () {
      return {
        list: [],
        showAnswer: false
      }
    },
    filters: {
      typeQuesNum (items) {
        let num = 0
        _.each(items, item => {
          num += item.testNum
        })
        return num
      }
    },
    computed: {
      ...mapState('pop', ['basketQuesListPopVisible']),
      ...mapGetters('common', ['currentSubject']),
      ...mapGetters('basket', ['quesBasket', 'quesBasketTypeList']),
      subjectID () {
        return this.currentSubject.id
      },
      testList () {
        return (this.quesBasket && this.currentSubject) ? this.quesBasket[this.subjectID] : {}
      }
    },
    watch: {
      'basketQuesListPopVisible': {
        handler (n, o) {
          if (n) {
            /* 清空list，触发视图更新 修复列表不能滚动问题 */
            this.list = []
            this.$nextTick(() => {
              this.list = this.quesBasketTypeList
              this.open()
            })
          }
        },
        immediate: true
      },
      quesBasketTypeList () {
        this.list = this.quesBasketTypeList
      }
    },
    methods: {
      ...mapMutations('pop', ['updateBasketQuesListPopVisible']),
      open () {
        this.$refs.basketQueListMsg.open()
      },
      close () {
        this.updateBasketQuesListPopVisible(false)
      },
      isShowAnswer (val) {
        _.each(this.$refs.QuestionItem, item => {
          item.bindShowAnswer(val)
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../../styles/_mixins-wln";
  .comp-basket-question-list-pop {
    .el-main{
      padding: 0;
    }
    .color-second{
      background: @second;
      border-color: @second;
      &:hover{
        opacity: .9;
      }
    }
    .w110{
      width: 110px;
    }
    #container{
      min-height: 200px;
    }
    .paper-aside{
      .el-checkbox__label{
        font-size: 12px;
      }
      &>div.fixed-top{
        position: fixed;
        top: 0;
        width: 260px;
      }
    }
    .ques-types{
      padding: 10px 3px 3px;
      .ps-paper-part-item {
        font-size: 12px;
        padding: 0 10px 10px;

        .paper-part-title {
          padding: 12px 0;
        }
      }

      .ps-ques-list {
        /*border-top: 1px dashed #ddd;*/

        .ques-name {
          padding: 2px 0 10px;
        }

        .order-list {
          display: flex;
          flex-wrap: wrap;
          margin: -5px;

          .order-item {
            display: inline-block;
            min-width: 30px;
            height: 30px;
            text-align: center;
            padding: 0 3px;
            line-height: 28px;
            border-radius: 2px;
            border: 1px solid #eee;
            cursor: pointer;
            margin: 5px;

            &:hover {
              background-color: @primary;
              color: #fff;
              border-color: @primary;
            }
          }
        }
      }
    }
    .btns .btn-primary{
      background: @second;
      border-color: @second;
      &:hover{
        opacity: .9;
      }
    }
  }
</style>
